import EventBus from '@/js/util/EventBus'

import filter from '@/js/util/symbols/filter'
import propsTag from '@/js/util/props/propsTag'

export default {
  name: 'BaseFilter',
  provide() {
    return {
      [filter]: this,
    }
  },
  props: {
    ...propsTag,

    amount: {
      type: Number,
      default: 6,
    },
    endpoint: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      filtered: [],
      checkboxes: [],
      checkedTitles: [],
      checkedTitlesData: [],

      amountShown: this.amount,
      activeCheckbox: undefined,

      title: '',
      search: '',
      showModal: false,
      apiEndpoint: this.endpoint,
    }
  },

  created() {
    EventBus.$on('reset:all', this.resetAll)
    this.$on('set:modal', this.setShowModal)
    this.$on('reset:single', this.resetSingle)
    this.$on('set:checkbox', this.setActiveCheckbox)
    this.$on('set:filtered', this.setFilteredShown)
    this.$on('create:search', this.createSearchQuery)
    this.$on('create:checkboxes', this.createCheckboxes)
    this.$on('create:title', this.createTitle)
    this.$on('create:filtered', this.createFiltered)
  },

  mounted() {
    this.fetchData()
  },

  computed: {
    checked() {
      return this.checkboxes.filter(({ checked }) => checked)
    },

    checkedUrlParams() {
      const params = {}
      this.checked.forEach(({ type, filterKey }) => {
        const dynamicKey = params[filterKey]
        if (!dynamicKey || !dynamicKey.length) {
          params[filterKey] = []
        }
        params[filterKey].push(type)
      })
      return params
    },
    buildCheckedUrlParams() {
      let params = ''
      Object.entries(this.checkedUrlParams).forEach((param) => {
        const [filterKey, type] = param
        params += `&${filterKey}=${type}`.split(',').join('+')
      })
      return params
    },
    buildUrlEndpoint() {
      return `${this.apiEndpoint}${this.buildCheckedUrlParams}${this.title}`
    },
  },

  watch: {
    title: 'fetchData',
    checked: 'fetchData',
  },

  methods: {
    createSearchQuery(query) {
      this.title = `&title=${query}&filter_tags=${query}`
    },

    createTitle(item) {
      const index = this.checkedTitles.indexOf(item.title)
      if (index > -1) {
        this.checkedTitles.splice(index, 1)
        this.checkedTitlesData.splice(index, 1)
        return
      }
      this.checkedTitles.push(item.title)
      this.checkedTitlesData.push(item)
    },

    resetSingle(item) {
      const index = this.checkedTitles.indexOf(item.title)
      if (index === -1) {
        return
      }
      this.checkedTitles.splice(index, 1)
      this.checkedTitlesData.splice(index, 1)
    },
    resetAll() {
      this.checkedTitles = []
      this.checkedTitlesData = []
      EventBus.$emit('uncheck:checkboxes', false)
    },

    setShowModal(state) {
      this.showModal = state
    },

    setFilteredShown() {
      this.amountShown += this.amount
    },

    setActiveCheckbox(checkbox) {
      this.activeCheckbox = checkbox
    },
    createCheckboxes(checkbox) {
      this.checkboxes.push(checkbox)

      if (!this.activeCheckbox) {
        this.setActiveCheckbox(checkbox)
      }
    },

    createFiltered(filtered) {
      this.filtered = filtered
    },

    async fetchData() {
      if (!this.endpoint) {
        return
      }

      const response = await (
        await fetch(this.buildUrlEndpoint, {
          headers: {
            accept: 'application/json',
            'content-type': 'application/json',
          },
        })
      ).json()

      this.filtered = response
    },
  },

  render(createElement) {
    return createElement(this.tag, this.$slots.default)
  },
}



// WEBPACK FOOTER //
// ./src/js/components/BaseFilter.js